import auth from '@/middlewares/auth'
import autoLogin  from '@/middlewares/autoLogin'
import routerName from '@/constants/routers'

export default [
    {
        path: '/',
        component: () => import( /* webpackChunkName: "optimization" */ './views/layout.vue'),
        children : [
            {
                path: 'actual-speed',
                name: routerName.OPTIMIZE_IMAGE,
                meta : {
                    middleware : [ autoLogin , auth ],
                    breadcrumb: [
                        { name: 'Actual Speed' }
                    ]
                },
                component: () => import( /* webpackChunkName: "default-page" */ './views/index.vue')
            },
            {
                path: 'actual-speed/:id',
                name: routerName.OPTIMIZATION_DETAIL,
                meta: {
                    middleware : [ autoLogin , auth ],
                    breadcrumb: [
                        { name: 'Actual Speed', route: routerName.OPTIMIZE_IMAGE},
                        { name: 'Detail'}
                    ]
                },
                component: () => import( /* webpackChunkName: "optimization-detail" */ './views/detail.vue')
            }
        ]
    }
]